<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"EMPLOYEE.JOBPREFERENCE.JOBPREFERENCE"|translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column justify-content-center">
    <form action="" class="o-h" [formGroup]="addForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6 mt-3 ">
          <label for="">{{"COMMON.CATEGORY"|translate}}</label>
          <mat-select class="form-control" placeholder="{{'COMMON.SELECT' | translate}} {{'COMMON.CATEGORY'|translate}}" 
           formControlName="j_c" (selectionChange)="onSelectCategory($event)">
            <mat-option *ngFor="let item of categoryArr" [value]="item.j_c"> {{item.j_c}} </mat-option>
          </mat-select>
          <mat-error *ngIf="isControlHasError('j_c','required')"> {{"This is required"|translate}}</mat-error>
        </div>
        <div class="col-md-6 mt-3">
          <label for="">{{"COMMON.SUBCATEGORY"|translate}}</label>
          <ng-multiselect-dropdown  [settings]="dropdownSettings" [data]="subCategoryArr" formControlName="j_sc">
          </ng-multiselect-dropdown>
          <mat-error *ngIf="isControlHasError('j_sc','required')"> {{"This is required"|translate}}</mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mt-3 mt-lg-4">
          <label for="">{{"COMMON.ADDRESS"|translate}}</label>
          <textarea name="" class="form-control" id="" cols="10" rows="3" formControlName="add"></textarea>
          <mat-error *ngIf="isControlHasError('add','required')"> {{"This is required"|translate}}</mat-error>
        </div>       
      </div>
      <div class="row">
        <div class="col-12 mt-3 mt-3 mt-lg-4">
          <label for="">{{"EMPLOYEE.JOBPREFERENCE.SHIFT"|translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control" formControlName="s_pw"
              placeholder="{{'COMMON.ENTER' | translate}} {{'EMPLOYEE.JOBPREFERENCE.SHIFT' | translate}}">
          </div>
          <mat-error *ngIf="isControlHasError('s_pw','required')"> {{"This is required"|translate}}</mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-3">
          <mat-checkbox name="agree" class="c-s" formControlName="int_ft" >
            <div class="text-wrap">{{"EMPLOYEE.JOBPREFERENCE.INTERESTED"|translate}}</div>
        </mat-checkbox>
        </div>
        <div class="col-md-6 mt-3">
          <mat-checkbox name="agree" class="c-s" formControlName="w_tt">
            <div class="text-wrap">{{"EMPLOYEE.JOBPREFERENCE.WILLING"|translate}}</div>
        </mat-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <mat-checkbox name="agree" class="c-s" formControlName="un_mi">
            <div class="text-wrap">{{"EMPLOYEE.JOBPREFERENCE.UNLIMITED"|translate}}</div>
        </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">{{
        "Save" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>